const Loader = ({ label = 'Collecte des données EONET…' }) => (
    <div className="loader" role="status" aria-live="polite">
        <span className="loader__flame" aria-hidden="true" />
        <p className="loader__label">{label}</p>
        <div className="skeleton-list" aria-hidden="true">
            {Array.from({ length: 6 }, (_, i) => <span key={i} className="skeleton" />)}
        </div>
    </div>
)

export default Loader
